import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import {
  trigger,
  transition,
  query,
  style,
  animate,
  group,
} from "@angular/animations";
import { CustomerSettingService } from "src/app/shared/service/customer-setting.service";
import { AgencyService } from "src/app/shared";
import { NgxSpinnerService } from "ngx-spinner";
import { DashboardService } from "src/app/shared/service/dashboard.service";
import * as Chart from "chart.js";
import { FormBuilder, FormGroup } from "@angular/forms";
declare var Swal: any;
declare var jquery: any;
declare var $: any;
import { parse } from "date-fns";

@Component({
  selector: "app-graph-forgot-check",
  templateUrl: "./graph-forgot-check.component.html",
  styleUrls: ["./graph-forgot-check.component.css"],
})
export class GraphForgotCheckComponent implements OnInit, AfterViewInit {
  slideTime: number = 8000;
  settings?: Array<any> = [];
  agencyList?: Array<any> = [];
  agencyName: string = "";
  agencyId: any;
  counter: number = 0;
  loading: boolean = true;
  foundData: boolean = false;
  message: string = "";
  lastUpdate: string = "";

  listAgencyLastupdate: AgencyLastUpage[] = [];


  isCustomer: boolean = false;
  loginAgentName: string = '';

  label: Array<any> = [];
  dataChart: Array<any> = [];
  sel_aggent: any;

  chart: any;
  private chartOptions: any;

  @ViewChild("canvas", { static: false })
  canvas!: ElementRef<HTMLCanvasElement>;
  public ctx: CanvasRenderingContext2D;

  public cboPreroid: any;
  public fromSelect: FormGroup;
  public selPreroid: string = "7";
  public selP: string = "7";



  constructor(
    private customerSettingService: CustomerSettingService,
    private agencyService: AgencyService,
    private spinner: NgxSpinnerService,
    private dashboardService: DashboardService,
    private fb: FormBuilder
  ) {

    this.checkIsCustomer();

    this.getAgentcyList();

    this.fromSelect = fb.group({
      sel_preriod: [this.selPreroid],
      sel_aggent: ''
    });
  }

  checkIsCustomer() {
    let role = localStorage.getItem('role');
    this.isCustomer = (role === 'CUSTOMER');

    if (!this.isCustomer && role === 'AGENCY') {
      this.loginAgentName = localStorage.getItem('agency_name');
    }
  }
  onChangeAgent(value) {
    console.log(value);
    this.sel_aggent = value;
    this.agencyId = value;
  }

  ngAfterViewInit(): void {
    this.chartOptions = {
      responsive: true,
      legend: {
        display: true,
      },
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              color: "#f3f3f3",
              drawTicks: false,
            },
            scaleLabel: {
              display: true,
            },
            ticks: {
              padding: 10,
            },
          },
        ],
        yAxes: [
          {
            display: true,
            gridLines: {
              color: "#f3f3f3",
              drawTicks: false,
            },
            scaleLabel: {
              display: true,
            },
            ticks: {
              padding: 10,
            },
          },
        ],
      },
      title: {
        display: false,
        text: "title",
      },
      animation: {
        onComplete: function () {
          var chartInstance = this.chart;
          var ctx = chartInstance.ctx;
          ctx.textAlign = "center";

          Chart.helpers.each(
            this.data.datasets.forEach(function (dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              Chart.helpers.each(
                meta.data.forEach(function (bar, index) {
                  ctx.fillText(
                    dataset.data[index],
                    bar._model.x,
                    bar._model.y - 10
                  );
                }),
                this
              );
            }),
            this
          );
        },
      },
    };

    this.ctx = this.canvas.nativeElement.getContext("2d");
    // this.monthIn = '1D';
    // this.monthOut = '1D';
    this.bindCharts(false);

    this.getChart();
  }

  getChart() {
    let data = [];
    this.dataChart = [];
    this.label = [];
    data.forEach((obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (key == "check_point_date") this.label.push(value);
        if (key == "total_count") this.dataChart.push(value);
      });
    });
    this.updateChartData(this.chart, this.label, this.dataChart);
  }

  bindCharts(isUpdate) {
    if (!isUpdate) {
      // Chart Data
      var chartData = {
        labels: this.label,
        datasets: [
          {
            type: "bar",
            label: "จำนวนบันทึกจุด",
            data: this.dataChart,
            backgroundColor: "#00A5A8",
            borderColor: "transparent",
            borderWidth: 2,
          },
        ],
      };

      var config = {
        type: "bar",
        options: this.chartOptions,
        data: chartData,
      };
      this.chart = new Chart(this.ctx, config);
    } else {
      this.removeChartData(this.chart);
      this.updateChartData(this.chart, this.label, this.dataChart);
    }
  }

  updateChartData(chart, label, data) {
    chart.data.labels = label;
    chart.data.datasets.forEach((dataset) => {
      dataset.data = data;
    });
    chart.update();
  }

  removeChartData(chart) {
    chart.data.labels = [];
    chart.data.datasets.forEach((dataset) => {
      dataset.data = [];
    });
    chart.update();
  }

  ngOnInit() {
  }


  onChangPreroid(value) {
    console.log(value);
    this.selPreroid = value;
  }
  onRefresh() {
    this.selP = this.selPreroid;
    this.loadRoundReport(true);
  }

  loadRoundReport(refresh?: boolean) {
    console.log("Agency Id ::" + this.agencyId);
    this.foundData = false;
    this.loadData();
  }

  loadData() {
    this.loading = true;
    let request = {
      agency_id: this.agencyId,
      preroid: parseInt(this.selP),
    };
    this.dashboardService.getDashbordChart(request).subscribe(
      (res) => {
        if (res.code == "success") {
          this.bindResponse(res);
        } else if (res.code === "not_found") {
          this.bindResponse(res);
        }
        this.loading = false;
      },
      (error) => {
        console.error(error);
        this.loading = false;
        this.failDialog(error);
      }
    );
  }

  bindResponse(res: any) {
    if (res.code == "success") {
      this.dataChart = [];
      this.label = [];
      res.data.forEach((obj) => {
        Object.entries(obj).forEach(([key, value]) => {
          if (key == "check_point_date") this.label.push(value);
          if (key == "total_count") this.dataChart.push(value);
        });
      });
      this.updateChartData(this.chart, this.label, this.dataChart);
      this.foundData = true;
    } else if (res.code === "not_found") {
      this.dataChart = [];
      this.label = [];
      this.updateChartData(this.chart, this.label, this.dataChart);
      this.foundData = false;
      this.message = res.message;
    }
  }
  getAgentcyList() {
    this.spinner.show();
    this.agencyService.get().subscribe(
      (data) => {

        if (this.isCustomer) {
          this.agencyList = data;
          console.log('no default agent login customer');
        }
        else {
          this.agencyList = data.filter(x => x.name == this.loginAgentName);;
          let find = this.agencyList;
          if (find.length > 0) {
            this.agencyName = find[0].name;
            this.agencyId = find[0].id;
          }

          console.log('default agent id : ' + this.agencyId);
        }

        if (this.agencyList.length > 0) {
          setTimeout(() => {
            this.fromSelect.patchValue(
              {
                sel_aggent: this.agencyList[0].id
              }
            );
            this.agencyName = this.agencyList[0].name;
            this.agencyId = this.agencyList[0].id;
            this.loadRoundReport(true);
          }, 200);
        }
        this.spinner.hide();
        this.loading = false;
      },
      (error) => {
        console.error(error);
        this.failDialog(error);
        this.loading = false;
      }
    );
  }

  failDialog(msg) {
    Swal.fire({
      type: "error",
      title: "เกิดข้อผิดพลาด",
      text: msg,
    });
  }
}
interface AgencyLastUpage {
  id: number;
  lastupdate: Date;
  data: any;
}
